import React from 'react';
import ReactDOM from 'react-dom';

// Modal component
const Modal = ({ isOpen, onClose, title, titleLink, buttonLink, secondaryButtonLink, children }) => {
  if (!isOpen) return null;

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const onButtonClick = () => {
    window.open(buttonLink, '_blank');
  };

  const onSecondaryButtonClick = () => {
    window.open(secondaryButtonLink, '_blank');
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={stopPropagation}>
        <div className="modal-header">
          {title && (
            titleLink ? (
              <h2 className="modal-title">
                <a href={titleLink} target="_blank" rel="noreferrer" style={{ color: 'var(--color-primary)', textDecoration: 'none' }}>
                  {title}
                </a>
              </h2>
            ) : (
              <h2 className="modal-title">{title}</h2>
            )
          )}
          <div className="modal-buttons">
            {secondaryButtonLink && <button className="secondary-button modal-button" onClick={onSecondaryButtonClick}>
                  <i className="fa-solid fa-list"></i>
              </button>}
            {buttonLink && <button className="primary-button modal-button" onClick={onButtonClick}>
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
              </button>}
            <button className="close-button" onClick={onClose} aria-label="Close">
              ✕
            </button>
          </div>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default Modal;
